import { FiInstagram, FiFacebook } from "react-icons/fi";

const Footer = () => {
  const socials = [
    { icon: FiInstagram, label: "Instagram", url: "https://www.instagram.com/pannaiveetubiryani/" },
    { icon: FiFacebook, label: "Facebook", url: "https://www.facebook.com/pannaiveetubiryani/" },
    
  ];

  return (
    <footer id="footer" className="py-16 bg-black/80 border-t border-white/10">
      <div className="container grid gap-12 md:grid-cols-3 text-brand-cream/80">

        {/* Brand & Address */}
        <div>
          <p className="text-3xl font-display tracking-[0.2em] text-brand-gold">
            pannai veetu biryani
          </p>

          <p className="mt-4 text-sm leading-relaxed">
            No. 14, Pannai Veedu Street, Palladam Road,<br />
            Kongu Region, Tamil Nadu – 641662
          </p>

          <p className="mt-2 text-sm">Reservations: +91 73970 66555</p>
          <p className="text-sm">orders@pannaiveetubiryani.com</p>
        </div>

        {/* Hours */}
        <div>
          <p className="text-sm uppercase tracking-[0.3em] text-brand-gold">Hours</p>
          <ul className="mt-4 space-y-2 text-sm">
            <li>Monday - Thursday: 6pm – 11pm</li>
            <li>Friday - Saturday: 5pm – Midnight</li>
            <li>Sunday: Claypot Chef’s Table Only</li>
          </ul>
        </div>

        {/* Socials */}
        <div>
          <p className="text-sm uppercase tracking-[0.3em] text-brand-gold">Follow</p>
          <div className="mt-4 flex gap-4">
            {socials.map(({ icon: Icon, label, url }) => (
              <a
                key={label}
                href={url || "#"} target="_blank" rel="noopener noreferrer"
                aria-label={label}
                className="h-12 w-12 rounded-full border border-white/10 flex items-center justify-center hover:bg-white/10 transition"
              >
                <Icon className="text-xl" />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Copyright */}
      <p className="mt-10 text-center text-xs uppercase tracking-[0.3em] text-brand-cream/50">
        © {new Date().getFullYear()} Pannai Veetu Biryani. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
